import { useAuth } from 'modules/auth/hooks/useAuth';
import { useUser } from 'modules/user/hooks/useUser';

import { useAccount } from './useAccount';
import { useAccountJWT } from './useAccountJWT';
import { useInitTeamAccount } from './useInitTeamAccount';
import { useInitWorker } from './useInitWorker';

export const useInitAccount = () => {
  const { isLoggedIn } = useAuth();
  const {
    isFinance,
    isTeamAccountInitialized,
    userEndpointToken,
    workerToken,
  } = useAccount();

  const skipFetchingAccountJWT =
    !isTeamAccountInitialized || Boolean(userEndpointToken && workerToken);

  const { isUserInitialized } = useUser();

  const skipFetching = !isLoggedIn || !isUserInitialized || isFinance;

  useInitTeamAccount({ skipFetching });

  const { accountJWT } = useAccountJWT({
    skipFetching: skipFetching || skipFetchingAccountJWT,
  });

  useInitWorker({ accountJWT });
};
